"use strict";

import Common from "../Common";

//===================================================
//
// Constructor
//
//===================================================

/**
 * @constructor
 */
function Eraser() {
    // Constants.
    this.LINE_THICKNESS = 10;

    // Attributes.
    this._drawLayer = null;
    this._fillLayer = null;
    this._audio = null;
    this._arrCanvasContext = [];
}
export default Eraser;
//module.exports               	= Eraser;
Eraser.prototype.constructor = Eraser;


//===================================================
//
// Public
//
//===================================================

Eraser.prototype.init = function (drawLayer, fillLayer) {
    this._drawLayer = drawLayer;
    this._fillLayer = fillLayer;

    this._arrCanvasContext.push(this._drawLayer.context);
    this._arrCanvasContext.push(this._fillLayer._colourContext);
    this._arrCanvasContext.push(this._fillLayer._colourCodeContext);
};


//===================================================
//
// Private
//
//===================================================

Eraser.prototype._draw = function (context, from, to) {
    context.beginPath();
    context.lineWidth = this.LINE_THICKNESS;
    context.lineJoin = "round";
    context.moveTo(from.x, from.y);
    context.lineTo(to.x, to.y);
    context.closePath();
    context.stroke();
};

Eraser.prototype._stopAudio = function () {
    this._audio.howl.stop(this._audio.id);
    this._audio = null;
};


//===================================================
//
// Events
//
//===================================================

Eraser.prototype.onDrawBegan = function (point) {
    for (var context of this._arrCanvasContext) {
        context.save();
        context.globalCompositeOperation = "destination-out";
        context.strokeStyle = "rgba( 255, 255, 255, 255 )";

        this._draw(context, point, new PIXI.Point(point.x + 0.1, point.y + 0.1));
    }

    // TEST: DYN_OUT:
    var dynOutlineContext = Common.game.canvas.drawLayer.dynOutlineContext;
    dynOutlineContext.save();
    dynOutlineContext.globalCompositeOperation = "destination-out";
    dynOutlineContext.beginPath();
    dynOutlineContext.strokeStyle = "rgba( 255, 255, 255, 255 )";
    dynOutlineContext.lineWidth = this.LINE_THICKNESS;
    dynOutlineContext.lineJoin = "round";
    dynOutlineContext.moveTo(point.x, point.y);
    dynOutlineContext.lineTo(point.x + 0.1, point.y + 0.1);
    dynOutlineContext.closePath();
    dynOutlineContext.stroke();

    this._drawLayer.onContext_Changed();
    this._fillLayer.onContext_Changed();
};

Eraser.prototype.onDrawMoved = function (from, to) {
    // Sfx.
    if (this._audio == null)
        this._audio = Common.audio.playSound("sfx_tool_eraser_loop_03", {"loop": true});
    TweenMax.killDelayedCallsTo(this._stopAudio);
    TweenMax.delayedCall(0.25, this._stopAudio, null, this);


    this._lastPosition = Common.renderer.plugins.interaction.mouse.global;

    for (var context of this._arrCanvasContext)
        this._draw(context, from, to);

    this._drawLayer.onContext_Changed();
    this._fillLayer.onContext_Changed();

    // TEST: DYN_OUT:
    var dynOutlineContext = Common.game.canvas.drawLayer.dynOutlineContext;
    dynOutlineContext.beginPath();
    dynOutlineContext.lineWidth = this.LINE_THICKNESS;
    dynOutlineContext.lineJoin = "round";
    dynOutlineContext.moveTo(from.x, from.y);
    dynOutlineContext.lineTo(to.x, to.y);
    dynOutlineContext.closePath();
    dynOutlineContext.stroke();
};

Eraser.prototype.onDrawEnded = function () {
    // Sfx.
    TweenMax.killDelayedCallsTo(this._stopAudio);
    if (this._audio != null)
        this._stopAudio();


    for (var context of this._arrCanvasContext)
        context.restore();

    // TEST: DYN_OUT:
    var dynOutlineContext = Common.game.canvas.drawLayer.dynOutlineContext;
    dynOutlineContext.restore();
    Common.game.canvas.drawLayer._dynOutlineLayerData = dynOutlineContext.getImageData(0, 0, Common.game.canvas.WIDTH, Common.game.canvas.HEIGHT);

    this._fillLayer.updateContextData();
};


//===================================================
//
// Getters / Setters
//
//===================================================

// TODO: